/** Connections — the runtime targets Forge reaches, and nothing else. */
import { ConnectionsRuntimeSection } from "./ConnectionsSettings";
import { SettingsPageContainer } from "./settingsLayout";

export function ConnectionsSettingsPage() {
  return (
    <SettingsPageContainer>
      <ConnectionsRuntimeSection />
    </SettingsPageContainer>
  );
}
